import { Menu, MenuProps, styled } from '@mui/material'

export const StyledMenu = styled((props: MenuProps) => (
  <Menu
    autoFocus={false}
    elevation={10}
    transformOrigin={{ vertical: 'top', horizontal: 'center' }}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right'
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiMenu-list': {
    padding: 0
  },
  '& .MuiMenuItem-root': {
    padding: theme.spacing(1.5)
  },
  '& .MuiMenuItem-root.disableHover': {
    cursor: 'unset'
  },
  '& .MuiMenuItem-root.disableHover:hover': {
    backgroundColor: 'inherit'
  }
}))
